import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import ColorsFilter from 'components/essentials/ColorsFilter';
import ShopByHeaderSection from 'components/consumer/ShopByHeaderSection';
const MobileColorFilters = t0 => {
  const $ = _c(4);
  const {
    fabricColors,
    toggleSelectedColor,
    selectedColors
  } = t0;
  let t1;
  if ($[0] !== fabricColors || $[1] !== selectedColors || $[2] !== toggleSelectedColor) {
    t1 = <ShopByHeaderSection label="Color"><ColorsFilter colors={fabricColors} selectedColors={selectedColors} onSelectColor={toggleSelectedColor} variant="ShopByHeaderSection" /></ShopByHeaderSection>;
    $[0] = fabricColors;
    $[1] = selectedColors;
    $[2] = toggleSelectedColor;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
MobileColorFilters.propTypes = {
  fabricColors: PropTypes.node,
  toggleSelectedColor: PropTypes.func,
  selectedColors: PropTypes.node
};
export default MobileColorFilters;